/* eslint-disable no-console */
import { useState, useEffect } from "react";
import InputGroup from "../../../components/FormComponent/InputGroup";
import { httprequest } from "../../../data/api";
import { toast } from "react-toastify";
import BreadCrumb from "../../../components/BreadCrumb";
import Layout from "../../../components/Layout";
import SelectGroup from "../../../components/FormComponent/SelectGroup";
import { Grid,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TableContainer,
  Paper } from "@mui/material";
import useStyles from "../styles";
import Button from "../../../components/Button";
import TextAreaGroup from "../../../components/FormComponent/TextAreaGroup";
import { useUserState } from "../../../context/UserContext";
import { useNavigate, useParams } from "react-router-dom";
// import { useUpload } from "../../../hooks/useUpload";
import NoData from "../../dashboard/components/NotFoundCard/NoData";
import nosearch from "../../../assets/images/no-search.svg";
import PageLoader from "../../../components/PageLoader";

const TERM_ENDPOINT = "/api/v1/school-plan/terms";

const SESSION_ENDPOINT = "/api/v1/school-plan/session";
const ADMIN_CLASS_ENDPOINT = "/api/v1/class";
const REPORT_ENDPOINT = "/api/v1/student-report/";
const GRADING_SYSTEM = "/api/v1/grading-system";
const EXTRAS_ENDPOINT = "/api/v1/school-extras";
const READY_REPORT_ENDPOINT = "/api/v1/student-reports";
const OBTAINABLE_SCORE = "/api/v1/obtainable-score";

const EditReport = () => {
  const classes = useStyles();
  const { id } = useParams();
  const navigate = useNavigate();
  const [allTerm, setAllTerms] = useState([]);
  const [sessionData, setSessionData] = useState([]);
  const [classData, setClassData] = useState([]);
  const { userRole } = useUserState();
  const isTeacher = userRole?.role_type === "employee";
  const [allGradingSystem, setAllGradingSystem] = useState([]);
  const [formData, setFormData] = useState({
    student_name: "",
    session: "",
    term_id: "",
    class_id: "",
    student_type: "",
    results: [],
    extras: [],
    activities: [],
    teacher_comment: ""
  });
  // eslint-disable-next-line no-unused-vars
  const [extraData, setExtrasData] = useState([]);
  const [isPageFetching, setIsPageFetching] = useState(false);
  const [reportData, setReportData] = useState([]);
  const [obtainablescore, setObtainableScore] = useState([]);

  const fetchClasses = () => {
    httprequest
      .get(ADMIN_CLASS_ENDPOINT)
      .then((res) => {
        setClassData(res?.data?.data);
      })
      .catch(() => {
      });
  };

  /**
     * Fetches all available academic sessions from the backend.
     * Updates the sessionData state with the fetched data.
     */
  const getAllSession = () => {
    httprequest
      .get(SESSION_ENDPOINT)
      .then((res) => {
        setSessionData(res?.data?.data);
      })
      .catch(() => {});
  };

  /**
     * Fetches all terms from the backend and filters by session ID.
     * @param {string} Session_id - The ID of the selected session.
     */
  const getAllTerms = (Session_id) => {
    httprequest
      .get(TERM_ENDPOINT)
      .then((res) => {
        setAllTerms(res?.data?.data.filter((session_term) => session_term?.session_id === Session_id));
        // setActiveTerm(
        //   res?.data?.data.filter(
        //     (active_term) => active_term?.is_current === true
        //   )
        // );
      })
      .catch((err) => {
        toast.error(err?.response?.data);
      });
  };

  const handleGetAllGradingSystem = () => {
    httprequest.get(GRADING_SYSTEM).then((res) => {
      setAllGradingSystem(res?.data?.data);
    }).catch((err) => {
      toast.error(err?.response?.data?.message);
    });
  };

  const handleEditSessionChange = (e) => {
    const { value } = e.target;
    // setAssignmentForm({ ...assignmentForm, [name]: value });
    getAllTerms(value);
  };

  const getAllExtras = () => {
    httprequest
      .get(EXTRAS_ENDPOINT)
      .then((res) => {
        setExtrasData(res.data.data);

        if (res.data.data && res.data.data.extras) {
          const defaultExtras = res.data.data.extras.map((extra) => ({
            section_name: extra.section_name,
            section_type: extra.section_type,
            section_value: (extra.section_titles || []).reduce((acc, title) => {
              acc[title] = "";

              return acc;
            }, {})
          }));

          setFormData(prev => ({
            ...prev,
            extras: defaultExtras
          }));
        }
      })
      .catch((err) => {
        toast.error(err?.response?.data);
      });
  };

  const getAllObtainableScores = (session_id) => {
    httprequest
      .get(OBTAINABLE_SCORE)
      .then((res) => {
        setObtainableScore(res?.data?.data?.filter((scores) => scores?.session?.id === session_id));
      })
      .catch(() => {});
  };

  const fetchReportData = async () => {
    setIsPageFetching(true);

    try {
      let response;
      const urlParams = new URLSearchParams(window.location.search);
      const termId = urlParams.get("term_id");
      const classId = urlParams.get("class_id");

      if (window.location.pathname.includes("student/")) {
        const studentId = id.replace("student/", "");
        const queryParams = [];

        if (studentId) queryParams.push(`student_id=${studentId}`);
        if (termId) queryParams.push(`term_id=${termId}`);
        if (classId) queryParams.push(`class_id=${classId}`);

        const queryString = queryParams.length > 0 ? `?${queryParams.join("&")}` : "";
        response = await httprequest.get(`/api/v1/student-reports/combine${queryString}`);
      } else {
        response = await httprequest.get(`${REPORT_ENDPOINT}?report_ids=${id}`);
      }

      const report = Array.isArray(response?.data?.data) ?
        response?.data?.data[0] :
        response?.data?.data;

      if (!report) {
        throw new Error("No report data received");
      }

      const activities = [];
      (report.extras || []).forEach(section => {
        if (section.section_type === "grade" || section.section_type === "score") {
          Object.entries(section.section_value || {}).forEach(([activity, value]) => {
            activities.push({
              activity,
              value,
              type: section.section_type,
              sectionName: section.section_name
            });
          });
        }
      });

      setFormData(prev => ({
        ...prev,
        student_name: `${report?.first_name} ${report?.last_name}`,
        session: report.session?.id || "",
        term_id: termId || report?.term?.id || "",
        class_id: classId || report?.class?.id || "",
        student_type: "",
        subjects: report?.subjects || [],
        extras: report?.extras?.length > 0 ? report.extras : prev.extras,
        activities: [],
        teacher_comment: (report?.extras || []).find(e => e.section_name === "teacher's comment")?.section_value || ""
      }));

      setReportData(report);

      if (report.session?.id) {
        getAllTerms(report.session.id);
        getAllObtainableScores(report.session.id);
      }
    } catch (error) {
      toast.error(error.response?.data?.message);
    } finally {
      setIsPageFetching(false);
    }
  };

  const handleActivityChange = (sectionName, originalActivityKey, field, value) => {
    if (field === "activity") {
      // Handle activity name (key) changes
      setFormData(prev => {
        // Update extras with new key
        const updatedExtras = prev.extras.map(section => {
          if (section.section_name === sectionName) {
            const newSectionValue = { ...section.section_value };
            // eslint-disable-next-line no-undefined
            if (newSectionValue[originalActivityKey] !== undefined) {
              newSectionValue[value] = newSectionValue[originalActivityKey];
              delete newSectionValue[originalActivityKey];
            }

            return {
              ...section,
              section_value: newSectionValue
            };
          }

          return section;
        });

        // Update activities with new key
        const updatedActivities = prev.activities.map(activity => {
          if (activity.activity === originalActivityKey &&
                    activity.sectionName === sectionName) {
            return {
              ...activity,
              activity: value
            };
          }

          return activity;
        });

        return {
          ...prev,
          extras: updatedExtras,
          activities: updatedActivities
        };
      });
    } else {
      // Handle value changes (grade/score)
      setFormData(prev => {
        const updatedActivities = [...prev.activities];
        const activityIndex = updatedActivities.findIndex(
          a => a.activity === originalActivityKey &&
                     a.sectionName === sectionName
        );

        if (activityIndex !== -1) {
          updatedActivities[activityIndex] = {
            ...updatedActivities[activityIndex],
            [field]: value
          };
        } else {
          updatedActivities.push({
            activity: originalActivityKey,
            [field]: value,
            type: field === "value" && !isNaN(value) ? "score" : "grade",
            sectionName
          });
        }

        return {
          ...prev,
          activities: updatedActivities
        };
      });
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSave = async () => {
    try {
      const transformedExtras = [];

      const gradeActivities = formData.activities
        .filter(activity => activity.type === "grade")
        .reduce((acc, curr) => {
          acc[curr.activity] = curr.value;

          return acc;
        }, {});

      if (Object.keys(gradeActivities).length > 0) {
        transformedExtras.push({
          section_name: "extracurriculars",
          section_type: "grade",
          section_value: gradeActivities
        });
      }

      const scoreActivities = formData.activities
        .filter(activity => activity.type === "score")
        .reduce((acc, curr) => {
          acc[curr.activity] = Number(curr.value);

          return acc;
        }, {});

      if (Object.keys(scoreActivities).length > 0) {
        transformedExtras.push({
          section_name: "social",
          section_type: "score",
          section_value: scoreActivities
        });
      }

      if (formData.teacher_comment) {
        transformedExtras.push({
          section_name: "teacher's comment",
          section_type: "text",
          section_value: formData.teacher_comment
        });
      }

      // Prepare the payload
      const payload = {
        term_id: formData.term_id,
        class_id: formData.class_id,
        students: [
          {
            student_id: id,
            extras: transformedExtras
          }
        ]
      };

      // Send the request
      const response = await httprequest.post(`${REPORT_ENDPOINT}`, payload);

      toast.success(response.data.message || "Report saved successfully");
      setTimeout(() => {
        navigate("/report/reports");
      }, 1300);
    } catch (error) {
      toast.error(error.response?.data?.message || "Failed to save report");
    }
  };

  const handlePublish = async () => {
    try {
      const finalResponse = await httprequest.patch(`${READY_REPORT_ENDPOINT}/ready-for-publish`, {
        report_ids: [id]

      });

      toast.success(finalResponse.data.message || "Report published and uploaded successfully");
      setTimeout(() => {
        navigate("/report/reports");
      }, 1300);
    } catch (error) {
      toast.error(error.response?.data?.message || "Failed to publish report");
    }
  };

  useEffect(() => {
    getAllExtras();
    fetchReportData();
    fetchClasses();
    getAllTerms();
    getAllSession();
    handleGetAllGradingSystem();
  }, []);

  const handleGoBack = () => {
    navigate(-1);
  };

  return (
    <Layout children={
      <>
        <BreadCrumb
          link_one={`${isTeacher ? "/reports/reports" : "/report/reports"}`}
          link_one_name="Reports"
          active="Edit Report"
          description="Manage students reports here."
        />

        {isPageFetching ? (
          <PageLoader />
        ) : (
          <>
            {!reportData || Object.keys(reportData).length === 0 ? (
              <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }} className="page-content container-border">
                <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                  <NoData
                    title="Report Unavailable"
                    subtitle="No Result uploaded or is currently being processed"
                    img={nosearch}
                  />
                  <Button
                    variant="primary"
                    buttonSize="medium"
                    color="btndefault"
                    buttonName="Return To Report"
                    onClick={handleGoBack}
                  />
                </div>
              </div>
            ) : (
              <div className="page-content margin-top-30">
                <Grid container spacing={2} className="input-padding">
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <InputGroup
                      inputType="text"
                      label="Student Name"
                      inputName="stduent_name"
                      value={formData.student_name}
                    />
                  </Grid>
                  <Grid item lg={6} md={6} sm={12} xs={12}>
                    <SelectGroup
                      label="Select Session"
                      required
                      children={
                        <select
                          name="session"
                          value={formData.session}
                          onChange={handleEditSessionChange}
                        >
                          <option value="">---Select---</option>
                          {sessionData?.map((sesh) => {
                            return (
                              <option key={sesh?.id} value={sesh?.id}>
                                {sesh?.session}
                              </option>
                            );
                          })}
                        </select>
                      }
                    />
                    {/* {assignmentValidator.message("Session", assignmentForm?.session, "required")} */}
                  </Grid>
                  <Grid item lg={6} md={6} sm={12} xs={12}>
                    <SelectGroup
                      label="Select Term"
                      required
                      children={
                        <select
                          name="term_id"
                          value={formData.term_id}
                          onChange={handleInputChange}
                        >
                          <option value="">--- Select ---</option>
                          {allTerm?.map((term) => (
                            <option key={term?.id} value={term?.id}>
                              {term?.term}
                            </option>
                          ))}
                        </select>
                      }
                    />
                  </Grid>
                  <Grid item lg={6} md={6} sm={12} xs={12}>
                    <SelectGroup
                      label="Select Class"
                      required
                      children={
                        <select
                          name="class_id"
                          value={formData.class_id}
                          onChange={handleInputChange}
                        >
                          <option value="">--- Select ---</option>
                          {classData?.map((clss) => (
                            <option key={clss?.id} value={clss?.id}>
                              {clss?.class_name}
                            </option>
                          ))}
                        </select>
                      }
                    />
                  </Grid>
                  {/* <Grid item lg={6} md={6} sm={12} xs={12}>
                    <SelectGroup
                      label="Student Type"
                      required
                      children={
                        <select
                          name="class_id"
                        >
                          <option value="">--- Select ---</option>
                        </select>
                      }
                    />

                  </Grid> */}
                </Grid>
                <div className="margin-top-16">
                  <p className="margin-top-16" style={{ textAlign: "left", width: "fit-content", fontWeight: "bold" }}>Subject Results</p>
                  <TableContainer component={Paper} className={classes.tableContainer}>
                    <Table>
                      <TableHead>
                        <TableRow>
                          <TableCell className={classes.subjectHeader}>Subject</TableCell>
                          {obtainablescore?.[0]?.ca?.map((ca, index) => (
                            <TableCell key={index} className={classes.headerCell}>
                              {ca?.ca_type} ({ca?.score})
                            </TableCell>
                          ))}
                          <TableCell className={classes.headerCell}>Exam (60)</TableCell>
                          <TableCell className={classes.headerCell}>Total (100)</TableCell>
                          {/* <TableCell className={classes.headerCell}>Term1 (100)</TableCell> */}
                          <TableCell className={classes.headerCell}>Class Highest</TableCell>
                          <TableCell className={classes.headerCell}>Class Lowest</TableCell>
                          <TableCell className={classes.headerCell}>Class Average</TableCell>
                          <TableCell className={classes.headerCell}>Grade</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {reportData?.subjects?.map((row, idx) => (
                          <TableRow key={idx}>
                            <TableCell sx={{
                              position: "sticky",
                              left: 0,
                              backgroundColor: "#fff",
                              zIndex: 1
                            }}
                            >{row.name}
                            </TableCell>
                            {obtainablescore?.[0]?.ca?.map((ca, caIndex) => (
                              <TableCell key={caIndex} align="center">
                                {row?.scores?.CA_scores?.[ca?.ca_type] ?? "-"}
                              </TableCell>
                            ))}
                            <TableCell align="center">{row?.scores?.exam_score}</TableCell>
                            <TableCell align="center">{row?.scores?.total}</TableCell>
                            {/* <TableCell align="center">{row?.term1}</TableCell> */}
                            <TableCell align="center">{row?.scores?.class_highest_score}</TableCell>
                            <TableCell align="center">{row?.scores?.class_lowest_score}</TableCell>
                            <TableCell align="center">{row?.scores?.class_average_score?.toFixed(2)}</TableCell>
                            <TableCell align="center">{row?.scores?.grade}</TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </div>
                <div className={classes.extra}>
                  <p style={{ textAlign: "left", width: "fit-content", fontWeight: "bold" }}>Extracurriculars</p>
                  {formData.extras
                    .filter(section => section.section_type === "grade")
                    .map((section, sectionIndex) => (
                      <div key={`grade-section-${sectionIndex}`} style={{ marginBottom: "32px" }}>
                        <div className="flex gap-10" style={{ alignItems: "center", marginBottom: "16px" }}>
                          <p className={classes.extrahead}>{section.section_name.toUpperCase()}</p>
                          <p className={classes.extrahead}>Grade</p>
                        </div>

                        {Object.entries(section.section_value).map(([activity, grade], activityIndex) => (
                          <Grid container spacing={2} key={`grade-activity-${activityIndex}`} style={{ marginBottom: "16px", alignItems: "center" }}>
                            <Grid item lg={6} md={6} sm={12} xs={12}>
                              <InputGroup
                                inputName="name"
                                inputType="text"
                                value={activity}
                                disabled
                                onChange={(e) => handleActivityChange(
                                  section.section_name,
                                  activity,
                                  "activity",
                                  e.target.value
                                )
                                }
                              />
                            </Grid>
                            <Grid item lg={6} md={6} sm={12} xs={12}>
                              <SelectGroup
                                children={
                                  <select
                                    value={formData.activities.find(a => a.activity === activity &&
        a.sectionName === section.section_name
                                    )?.value || grade || ""}
                                    onChange={(e) => {
                                      const selectedGrade = e.target.value;
                                      handleActivityChange(
                                        section.section_name,
                                        activity,
                                        "value",
                                        selectedGrade
                                      );
                                    }}
                                  >
                                    <option value="">--- Select Grade ---</option>
                                    {(allGradingSystem[0]?.grading || []).map((grade_option, idx) => (
                                      <option key={idx} value={grade_option.grade}>
                                        {grade_option.grade}
                                      </option>
                                    ))}
                                  </select>
                                }
                              />

                            </Grid>
                          </Grid>
                        ))}
                      </div>
                    ))}

                  {formData.extras
                    .filter(section => section.section_type === "score")
                    .map((section, sectionIndex) => (
                      <div key={`score-section-${sectionIndex}`} style={{ marginBottom: "32px" }}>
                        <div className="flex gap-10" style={{ alignItems: "center", marginBottom: "16px" }}>
                          <p className={classes.extrahead}>{section.section_name.toUpperCase()}</p>
                          <p className={classes.extrahead}>Score</p>
                        </div>

                        {Object.entries(section.section_value).map(([activity, score], activityIndex) => (
                          <Grid container spacing={2} key={`score-activity-${activityIndex}`} style={{ marginBottom: "16px", alignItems: "center" }}>
                            <Grid item lg={6} md={6} sm={12} xs={12}>
                              <InputGroup
                                inputType="text"
                                disabled
                                value={activity}
                                onChange={(e) => handleActivityChange(
                                  section.section_name,
                                  activity,
                                  "activity",
                                  e.target.value
                                )
                                }
                              />
                            </Grid>
                            <Grid item lg={6} md={6} sm={12} xs={12}>
                              <InputGroup
                                inputType="number"
                                inputName="score"
                                value={formData.activities.find(a => a.activity === activity &&
    a.sectionName === section.section_name
                                )?.value || score || ""} onChange={(e) => handleActivityChange(
                                  section.section_name,
                                  activity,
                                  "value",
                                  e.target.value
                                )}
                                min="0"
                                max="100"
                              />
                            </Grid>
                          </Grid>
                        ))}
                      </div>
                    ))}
                </div>
                <Grid container spacing={2}>
                  <Grid item lg={6} md={6} sm={12} xs={12}>
                    <p style={{ textAlign: "left", width: "fit-content", margin: 0 }}>Teacher's Comment</p>
                    <TextAreaGroup
                      inputName="teacher_comment"
                      value={formData.teacher_comment}
                      margin="normal"
                      placeholder="Enter any additional information you would like to send."
                      onChange={handleInputChange}
                    />
                  </Grid>
                </Grid>
                <div className="flex gap-10 margin-top-30">
                  <Button
                    variant="dangeroutline"
                    buttonSize="fluid"
                    color="btndanger"
                    buttonName="Cancel"
                  />

                  <Button
                    variant="primaryoutline"
                    buttonSize="fluid"
                    color="btnfontprimary"
                    buttonName="Save"
                    onClick={handleSave}
                  />
                  <Button
                    variant="primary"
                    buttonSize="fluid"
                    color="btndefault"
                    buttonName="Ready to publish"
                    onClick={handlePublish}
                  />
                </div>
              </div>
            )}
          </>
        )}

        {/* <ToastContainer /> */}
      </>
    }
    />);
};

export default EditReport;
